<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/eja']"
              >Educação de Jovens e Adultos (EJA)</a
            >
          </div>
          <h1 class="title text-white">
            Conheça a Educação de Jovens e Adultos (EJA)
          </h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      A Facintec também oferta turmas de EJA, garantindo a conclusão dos estudos
      e a formação técnica para jovens e adultos. Descubra como concluir o
      ensino fundamental ou médio com qualificação profissional.
    </p>

    <a
      href="https://www.facintec.com.br/eja"
      class="rts-btn btn-primary with-arrow"
      >Saiba mais <i class="fa-solid fa-arrow-right"></i
    ></a>
  </div>
</div>
